
        window.__APP_ENV = import.meta.env;
    